import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';

import { Grid } from '../../lib/grid';
import { DataSource } from '../../lib/data-source/data-source';

@Component({
    selector: '[ng2-st-thead]',
    templateUrl: './thead.component.html',
    standalone: false
})
export class Ng2SmartTableTheadComponent implements OnChanges {
  @Input() public grid: Grid;
  @Input() public source: DataSource;
  @Input() public isAllSelected: boolean;
  @Input() public createConfirm: EventEmitter<any>;

  @Output() public sort = new EventEmitter<any>();
  @Output() public selectAllRows = new EventEmitter<any>();
  @Output() public add = new EventEmitter<any>();
  @Output() public filter = new EventEmitter<any>();
  @Output() public addCancel = new EventEmitter<any>();

  public isHideHeader: boolean;
  public isHideSubHeader: boolean;

  public ngOnChanges() {
    this.isHideHeader = this.grid.getSetting('hideHeader');
    this.isHideSubHeader = this.grid.getSetting('hideSubHeader');
  }
}
